export const cookieModalSelection = {
    data: [
        {
            description_consent:
                "Essenzielle Cookies sind alle notwendigen Cookies, die für den Betrieb der Webseite notwendig sind, indem Grundfunktionen ermöglicht werden. Die Webseite kann ohne diese Cookies nicht richtig funktionieren.",
            description_dse: "Hierbei speichern wir keine personenbezogenen Daten des Nutzers. ",
            choosable: false,
            name: "essential",
            label: "Essenzielle Cookies",
            itemize_dse_only: true,
            authors: [
                {
                    owner: "RTO GmbH",
                    description_consent: null,
                    processing_location: null,
                    description_dse: null,
                    name: "rto",
                    label: "RTO GmbH",
                    pivacy_policy_link: "https://www.rto.de/datenschutz",
                    collected_data: null,
                    cookies: [
                        {
                            portals: null,
                            lifetime: "Bis Ende der Sitzung",
                            name: "phpsessionid",
                            description: "Wiedererkennen der selben Nutzersitzung",
                            label: "PHPSESSIONID",
                            order: 1,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                                {
                                    name: "tgl",
                                    label: "Taschengeldladies.de",
                                },
                                {
                                    name: "thmlds",
                                    label: "Themenladies",
                                },
                                {
                                    name: "vlds",
                                    label: "Videoladies",
                                },
                                {
                                    name: "forum",
                                    label: "Ladies-Forum.de",
                                },
                                {
                                    name: "fkk",
                                    label: "FKK24.de",
                                },
                            ],
                            lifetime: "Bis Ende der Sitzung",
                            name: "phpsessid",
                            description: "Wiedererkennen der selben Nutzersitzung",
                            label: "PHPSESSID",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "tgl",
                                    label: "Taschengeldladies.de",
                                },
                                {
                                    name: "thmlds",
                                    label: "Themenladies",
                                },
                            ],
                            lifetime: "1 Jahr",
                            name: "ladies_cookies_info",
                            description: "Verhindern, dass der Cookie-Hinweis immer wieder erscheint",
                            label: "ladies-cookies-info",
                            order: 2,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                                {
                                    name: "tgl",
                                    label: "Taschengeldladies.de",
                                },
                                {
                                    name: "thmlds",
                                    label: "Themenladies",
                                },
                            ],
                            lifetime: "30 Tage",
                            name: "live_merkzettel_count",
                            description: "Zwischenspeichern der Anzeigen-Anzahl des Merkzettels vom Nutzer",
                            label: "live-merkzettelCount",
                            order: 3,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                                {
                                    name: "tgl",
                                    label: "Taschengeldladies.de",
                                },
                                {
                                    name: "thmlds",
                                    label: "Themenladies",
                                },
                            ],
                            lifetime: "30 Tage",
                            name: "live_merkzettel_hash",
                            description:
                                "ID für die in unserer Datenbank gespeicherten Merkzettel-Einträge des Nutzers",
                            label: "live-merkzettelHash",
                            order: 4,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                                {
                                    name: "tgl",
                                    label: "Taschengeldladies.de",
                                },
                                {
                                    name: "thmlds",
                                    label: "Themenladies",
                                },
                            ],
                            lifetime: "Bis Ende der Sitzung",
                            name: "test_cookies",
                            description: "Prüfen, ob auf dem genutzten Gerät Cookies gesetzt werden können",
                            label: "testCookies",
                            order: 5,
                        },
                        {
                            portals: [
                                {
                                    name: "tgl",
                                    label: "Taschengeldladies.de",
                                },
                            ],
                            lifetime: "maximal 24 Stunden",
                            name: "overlay_ad",
                            description:
                                "Sicherstellen, dass der Overlay-Banner dem Nutzer nur einmal pro Tag angezeigt wird",
                            label: "OverlayAd",
                            order: 6,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                            ],
                            lifetime: "Bis Ende der Sitzung",
                            name: "news_umkreis",
                            description: "Speichern des eingestellten Umkreises auf der News-Übersichtsseite",
                            label: "newsUmkreis",
                            order: 7,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                            ],
                            lifetime: "Bis Ende der Sitzung",
                            name: "aktuelles_page",
                            description: "Speichern der aktuellen Seite bei den News (Regionen)",
                            label: "aktuellesPage",
                            order: 8,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                            ],
                            lifetime: "Bis Ende der Sitzung",
                            name: "ordered_adverts_config",
                            description:
                                "Speichern der nutzerbezogenen Konfiguration des Anzeigenmarkts (u.a. Sicherstellung der persistenten Reihenfolge)",
                            label: "orderedAdvertsConfig",
                            order: 8,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                                {
                                    name: "forum",
                                    label: "Ladies-Forum.de",
                                },
                            ],
                            lifetime: "24 Stunden",
                            name: "hide_on_cookie",
                            description:
                                "Sicherstellen, dass der Tagestipp-Banner nur einmal pro Tag und pro Auftrag ausgeklappt angezeigt wird",
                            label: "hide-on-cookie",
                            order: 9,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                                {
                                    name: "tgl",
                                    label: "Taschengeldladies.de",
                                },
                                {
                                    name: "thmlds",
                                    label: "Themenladies",
                                },
                                {
                                    name: "fkk",
                                    label: "FKK24.de",
                                },
                            ],
                            lifetime: "14 Tage",
                            name: "mobileversion",
                            description:
                                "Verhindern der Umleitung auf die Mobile-Version, wenn der Nutzer die PC-Version auf einem mobilen Endgerät aufrufen möchte",
                            label: "mobileversion",
                            order: 10,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                            ],
                            lifetime: "Bis zum Ende der Sitzung",
                            name: "clips-like-blacklist",
                            description: "Dient dem Schutz vor Missbrauch der Clips-Like-Funktion.",
                            label: "clips-like-blacklist",
                            order: 11,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                            ],
                            lifetime: "1 Jahr",
                            name: "locale",
                            description: "speichern der Sprachauswahl",
                            label: "locale",
                            order: 11,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                                {
                                    name: "forum",
                                    label: "Ladies-Forum.de",
                                },
                            ],
                            lifetime: "1 Jahr",
                            name: "cookies_accepted",
                            description:
                                "Verhindert, dass der Cookie-Banner auf Login-Subdomains nach Auswahl immer wieder erscheint",
                            label: "cookiesAccepted",
                            order: 12,
                        },
                        {
                            portals: [
                                {
                                    name: "forum",
                                    label: "Ladies-Forum.de",
                                },
                            ],
                            lifetime: "1 Jahr",
                            name: "bblastactivity",
                            description: "Datum der letzten Nutzer-Aktivität",
                            label: "bblastactivity",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "forum",
                                    label: "Ladies-Forum.de",
                                },
                            ],
                            lifetime: "1 Jahr",
                            name: "bblastvisit",
                            description: "Datum des letztes Besuches",
                            label: "bblastvisit",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "forum",
                                    label: "Ladies-Forum.de",
                                },
                            ],
                            lifetime: "1 Jahr",
                            name: "bbnp_notices_displayed",
                            description:
                                "Liste der Hinweise (Ankündigungen), die der Nutzer schon gesehen und geschlossen hat",
                            label: "bbnp_notices_displayed",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "forum",
                                    label: "Ladies-Forum.de",
                                },
                            ],
                            lifetime: "Bis Ende der Sitzung",
                            name: "bbsessionhash",
                            description: "Unique Session-Hash des eingeloggten Users",
                            label: "bbsessionhash",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "forum",
                                    label: "Ladies-Forum.de",
                                },
                            ],
                            lifetime: "1 Jahr",
                            name: "tokenstring",
                            description: "Multiple-Accounts Detektion",
                            label: "tokenstring",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "forum",
                                    label: "Ladies-Forum.de",
                                },
                            ],
                            lifetime: "Bis Ende der Sitzung",
                            name: "cpsession",
                            description: "Unique Admincp-Session-Hash des eingeloggten Admin-Users",
                            label: "cpsession",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "forum",
                                    label: "Ladies-Forum.de",
                                },
                            ],
                            lifetime: "1 Tag",
                            name: "scroll_to_profile",
                            description: "Zum Profil-Content-Teil scrollen, wenn ein Tab gewechselt wurde",
                            label: "scrollToProfile",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "forum",
                                    label: "Ladies-Forum.de",
                                },
                            ],
                            lifetime: "Bis Ende der Sitzung",
                            name: "user_selected_quotes",
                            description: "Themen-übergreifende Zitate",
                            label: "userSelectedQuotes",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "forum",
                                    label: "Ladies-Forum.de",
                                },
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                                {
                                    name: "fkk",
                                    label: "FKK24.de",
                                },
                                {
                                    name: "thmlds",
                                    label: "Themenladies",
                                },
                            ],
                            lifetime: "3 Monate",
                            name: "ladies_cookies_overlay",
                            description: "Speichern der Nutzer-Einstellungen der Cookie-Box",
                            label: "ladies-cookies-overlay",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                                {
                                    name: "forum",
                                    label: "Ladies-Forum.de",
                                },
                            ],
                            lifetime: "5 Jahre",
                            name: "remember_web",
                            description: "Login: Angemeldet bleiben",
                            label: "remember_web_*",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                                {
                                    name: "forum",
                                    label: "Ladies-Forum.de",
                                },
                            ],
                            lifetime: "2 Stunden",
                            name: "loginladiesde_session",
                            description: "Login: User-Session",
                            label: "loginladiesde_session",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "forum",
                                    label: "Ladies-Forum.de",
                                },
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                            ],
                            lifetime: "2 Stunden",
                            name: "xsrf_token",
                            description:
                                "Login: Sicherheitsmechanismus um vor Cross-Site-Request-Forgeries zu schützen",
                            label: "XSRF-TOKEN",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "fkk",
                                    label: "FKK24.de",
                                },
                            ],
                            lifetime: "30 Tage",
                            name: "lastldgb",
                            description: "Speichert die Länderauswahl auf der Events-Seite",
                            label: "lastldgb",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "fkk",
                                    label: "FKK24.de",
                                },
                            ],
                            lifetime: "1 Tag",
                            name: "page",
                            description: "Speichert die aktuelle Seitenauswahl auf der Girls-Seite",
                            label: "page",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "fkk",
                                    label: "FKK24.de",
                                },
                            ],
                            lifetime: "1 Tag",
                            name: "girls_page",
                            description: "Speichert die aktuelle Seitenauswahl auf der Girls-Seite",
                            label: "girlsPage",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "fkk",
                                    label: "FKK24.de",
                                },
                            ],
                            lifetime: "8 Stunden",
                            name: "girls_page_mobile",
                            description: "Speichert die aktuelle Seitenauswahl auf der Girls-Seite (Mobile)",
                            label: "girlsPageMobile",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "thmlds",
                                    label: "Themenladies",
                                },
                            ],
                            lifetime: "1 Stunde",
                            name: "anzeigen_selected_site",
                            description: "Speichern der von Nutzer ausgewählten Seite im Anzeigenmarkt.",
                            label: "anzeigenSelectedSite",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                            ],
                            lifetime: "1 Jahr",
                            name: "notice_fsk18_shown",
                            description:
                                "Speichern, dass der 18+ Hinweis durch den Nutzer bestätigt und ausgeblendet wurde",
                            label: "notice_fsk18_shown",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                                {
                                    name: "tgl",
                                    label: "Taschengeldladies.de",
                                },
                                {
                                    name: "thmlds",
                                    label: "Themenladies",
                                },
                                {
                                    name: "fkk",
                                    label: "FKK24.de",
                                },
                            ],
                            lifetime: "5 Minuten",
                            name: "jwt_auth",
                            description:
                                "Sicherstellen, dass der User erfolgreich den JavaScript Check durchlaufen hat",
                            label: "jwt_auth",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                                {
                                    name: "tgl",
                                    label: "Taschengeldladies.de",
                                },
                                {
                                    name: "thmlds",
                                    label: "Themenladies",
                                },
                                {
                                    name: "fkk",
                                    label: "FKK24.de",
                                },
                            ],
                            lifetime: "5 Minuten",
                            name: "verification_code",
                            description: "Wird während des JavaScript Checks verwendet",
                            label: "verification_code",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                            ],
                            lifetime: "1 Jahr",
                            name: "_ld_lrt",
                            description: "Login: Ein verschlüsselter LoginRefreshToken für Relogin-Zwecke",
                            label: "_ld_lrt",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                            ],
                            lifetime: "30 Tage",
                            name: "reminderHasUpdate",
                            description:
                                "Merkzettel: Wird zur Kommunikation zwischen Systemen genutzt, wenn der User eine Anzeige merkt",
                            label: "reminderHasUpdate",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                            ],
                            lifetime: "24 Tage",
                            name: "em-hide-Spiele",
                            description:
                                "Erlaubt es dem Besucher, den EM-Banner dauerhaft aus- oder wieder einzublenden",
                            label: "em-hide-Spiele",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                            ],
                            lifetime: "30 Tage",
                            name: "GuestRemindedAdvertList",
                            description:
                                "Merkzettel: Eine Liste an gemerkten Anzeigen im Zusammenhang mit der Listenansicht",
                            label: "GuestRemindedAdvertList",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                            ],
                            lifetime: "1 Minute",
                            name: "loginSuccess",
                            description: "Genutzt für das User Feedback in der Snackbar nach dem Login",
                            label: "loginSuccess",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                            ],
                            lifetime: "1 Minute",
                            name: "logoutSuccess",
                            description: "Genutzt für das User Feedback in der Snackbar nach dem Logout",
                            label: "logoutSuccess",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                            ],
                            lifetime: "1 Stunde",
                            name: "starProfileCalledFromMyStars",
                            description:
                                "Notwendig für die Deaktivierung des Star-Notification Symbols, wenn das Star-Profil aus der Stars-Übersicht aufgerufen wird",
                            label: "starProfileCalledFromMyStars",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                            ],
                            lifetime: "1 Stunde",
                            name: "myStarsNavigationUsed",
                            description:
                                "Notwendig für das nächste/vorherige Stars Feature, wenn der User aus der Stars-Übersicht auf das Star-Profil kommt und blättert",
                            label: "myStarsNavigationUsed",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                            ],
                            lifetime: "1 Stunde",
                            name: "subscriptionNotice",
                            description:
                                "Genutzt für das User Feedback in der Snackbar wenn ein Stars Abo gekauft wurde und die Seite danach neugeladen wird",
                            label: "subscriptionNotice",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                            ],
                            lifetime: "5 Minuten",
                            name: "midnightUserCacheResetDone",
                            description:
                                "Genutzt für das User Feedback in der Snackbar wenn nachts die Anzeigenübersicht automatisch aktualisiert wird",
                            label: "midnightUserCacheResetDone",
                            order: null,
                        },
                    ],
                    order: 1,
                },
                {
                    owner: "Cloudflare",
                    description_consent: null,
                    processing_location: null,
                    description_dse: null,
                    name: "cloudflare",
                    label: "Cloudflare",
                    pivacy_policy_link: null,
                    collected_data: null,
                    cookies: [
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                                {
                                    name: "tgl",
                                    label: "Taschengeldladies.de",
                                },
                                {
                                    name: "thmlds",
                                    label: "Themenladies",
                                },
                                {
                                    name: "fkk",
                                    label: "FKK24.de",
                                },
                                {
                                    name: "forum",
                                    label: "Ladies-Forum.de",
                                },
                                {
                                    name: "kol",
                                    label: "Kollegin.de",
                                },
                            ],
                            lifetime: "Verfällt nach höchstens 30 Minuten ununterbrochener Inaktivität des Nutzers",
                            name: "cf_bm",
                            description:
                                'Die Cloudflare-Bot-Produkte identifizieren und bekämpfen automatisierten Traffic, um diese Website vor schädlichen Bots zu schützen. Das Cookie __cf_bm ist erforderlich, damit diese Bot-Lösungen ordnungsgemäß funktionieren. Weitere Informationen unter <a href="https://support.cloudflare.com/hc/de/articles/200170156-Die-Cloudflare-Cookies-verstehen" target="_blank">https://support.cloudflare.com/hc/de/articles/200170156-Die-Cloudflare-Cookies-verstehen</a>.',
                            label: "__cf_bm",
                            order: 1,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                                {
                                    name: "tgl",
                                    label: "Taschengeldladies.de",
                                },
                                {
                                    name: "thmlds",
                                    label: "Themenladies",
                                },
                                {
                                    name: "vlds",
                                    label: "Videoladies",
                                },
                                {
                                    name: "forum",
                                    label: "Ladies-Forum.de",
                                },
                                {
                                    name: "fkk",
                                    label: "FKK24.de",
                                },
                                {
                                    name: "kol",
                                    label: "Kollegin.de",
                                },
                            ],
                            lifetime: "Bis Ende der Sitzung",
                            name: "cf_clearance",
                            description:
                                "Dieses Cookie speichert den Nachweis einer bestandenen Challenge. Es wird verwendet, um weitere Challenges nicht mehr auszustellen, falls diese angefordert werden. Es wird benötigt, um einen Herkunftsserver zu erreichen.",
                            label: "cf_clearance",
                            order: null,
                        },
                    ],
                    order: 2,
                },
            ],
            order: 1,
            timestamp: "2024-10-08T14:45:04.848530+02:00",
        },
        {
            description_consent:
                "Analyse- bzw. Statistikcookies sind Cookies, die der Analyse der Webseiten-Nutzung und der Erstellung von anonymisierten Zugriffsstatistiken dienen. Sie helfen den Webseiten-Besitzern zu verstehen, wie Besucher mit Webseiten interagieren, indem Informationen anonym gesammelt und gemeldet werden.",
            description_dse: null,
            choosable: true,
            name: "stats",
            label: "Analyse/Statistiken",
            itemize_dse_only: false,
            authors: [
                {
                    owner: "Google Ireland Limited",
                    description_consent:
                        'Wir nutzen Google Analytics, wodurch Drittanbieter-Cookies gesetzt werden. Näheres zu Google Analytics und zu den verwendeten Cookies sind unter folgendem Link und in der Datenschutzerklärung zu finden.\n<a href="https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage?hl=de#gtagjs_google_analytics_4_-_cookie_usage" target="_blank">https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage?hl=de#gtagjs_google_analytics_4_-_cookie_usage</a>',
                    processing_location: "Europäische Union & USA",
                    description_dse:
                        '            <p>\n                Es werden Third-Party-Cookies von Google Analytics verwendet. Weitere Informationen unter\n                <a href="https://policies.google.com/privacy?hl=en">https://policies.google.com/privacy?hl=en</a> und\n                <a href="https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage?hl=de#gtagjs_google_analytics_4_-_cookie_usage">\n                    https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage?hl=de#gtagjs_google_analytics_4_-_cookie_usage\n                </a>\n            </p>\n            <p>\n                <b>Welche Art von Daten werden gesammelt?</b>\n                <ul>\n                    <li>Herkunft (Land und Stadt)</li>\n                    <li>Sprache</li>\n                    <li>Betriebssystem</li>\n                    <li>Gerät (PC, Tablet-PC oder Smartphone)</li>\n                    <li>Browser und alle verwendeten Add-ons</li>\n                    <li>Auflösung des Computers</li>\n                    <li>Besucherqueller (Facebook, Suchmaschine oder verweisende Webseite)</li>\n                    <li>Welche Dateien wurden heruntergeladen?</li>\n                    <li>Welche Videos angeschaut?</li>\n                    <li>Wurden Werbebanner angeklickt?</li>\n                    <li>Wohin ging der Besucher? Klickte er auf weitere Seiten des Portals oder hat er sie komplett verlassen?</li>\n                    <li>Wie lange blieb der Besucher?</li>\n                </ul>\n            </p>',
                    name: "google_analytics",
                    label: "Google Analytics",
                    pivacy_policy_link: null,
                    collected_data:
                        "Die erzeugten Informationen über die Benutzung unserer Webseiten sowie die von dem Browser übermittelte IP-Adresse werden übertragen und gespeichert. Dabei können aus den verarbeiteten Daten pseudonyme Nutzungsprofile der Nutzer erstellt werden. Diese Informationen wird Google gegebenenfalls auch an Dritte übertragen, sofern dies gesetzlich vorgeschrieben wird oder, soweit Dritte diese Daten im Auftrag von Google verarbeiten. Die IP-Adresse der Nutzer wird von Google innerhalb von Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum gekürzt, dies bedeutet, dass alle Daten anonym erhoben werden. Nur in Ausnahmefällen wird die volle IP-Adresse an einen Server von Google in den USA übertragen und dort gekürzt.  Die von dem Browser des Nutzers übermittelte IP-Adresse wird nicht mit anderen Daten von Google zusammengeführt.\n<br /><br />\nErhobene Informationen zum Besucherverhalten sind folgende:\n<ul>\n  <li>Herkunft (Land und Stadt)</li>\n  <li>Sprache</li>\n  <li>Betriebssystem</li>\n  <li>Gerät (PC, Tablet-PC oder Smartphone)</li>\n  <li>Browser und alle verwendeten Add-ons</li>\n  <li>Auflösung des Computers</li>\n  <li>Besucherquelle (Facebook, Suchmaschine oder verweisende Webseite)</li>\n  <li>Welche Dateien wurden heruntergeladen?</li>\n  <li>Welche Videos angeschaut?</li>\n  <li>Wurden Werbebanner angeklickt?</li>\n  <li>Wohin ging der Besucher? Klickte er auf weitere Seiten des Portals oder hat er sie komplett verlassen?</li>\n  <li>Wie lange blieb der Besucher?</li>\n</ul>",
                    cookies: [
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                                {
                                    name: "tgl",
                                    label: "Taschengeldladies.de",
                                },
                                {
                                    name: "thmlds",
                                    label: "Themenladies",
                                },
                                {
                                    name: "fkk",
                                    label: "FKK24.de",
                                },
                                {
                                    name: "forum",
                                    label: "Ladies-Forum.de",
                                },
                                {
                                    name: "kol",
                                    label: "Kollegin.de",
                                },
                            ],
                            lifetime: "2 Jahre",
                            name: "ga",
                            description: "Dient der Unterscheidung von Benutzern",
                            label: "_ga",
                            order: 1,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                                {
                                    name: "tgl",
                                    label: "Taschengeldladies.de",
                                },
                                {
                                    name: "thmlds",
                                    label: "Themenladies",
                                },
                                {
                                    name: "fkk",
                                    label: "FKK24.de",
                                },
                                {
                                    name: "forum",
                                    label: "Ladies-Forum.de",
                                },
                                {
                                    name: "kol",
                                    label: "Kollegin.de",
                                },
                            ],
                            lifetime: "24 Stunden",
                            name: "gid",
                            description: "Dient der Unterscheidung von Benutzern",
                            label: "_gid",
                            order: 2,
                        },
                        {
                            portals: [
                                {
                                    name: "kol",
                                    label: "Kollegin.de",
                                },
                            ],
                            lifetime: "1 Minute",
                            name: "gat",
                            description: "Dient zur Verringerung der Anzahl der Datenübermittlungen an Google",
                            label: "_gat",
                            order: 2,
                        },
                        {
                            portals: [
                                {
                                    name: "tgl",
                                    label: "Taschengeldladies.de",
                                },
                                {
                                    name: "thmlds",
                                    label: "Themenladies",
                                },
                                {
                                    name: "fkk",
                                    label: "FKK24.de",
                                },
                                {
                                    name: "forum",
                                    label: "Ladies-Forum.de",
                                },
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                            ],
                            lifetime: "2 Jahre",
                            name: "ga_container_id",
                            description: "Wird verwendet, um den Sitzungsstatus zu erhalten",
                            label: "_ga_*",
                            order: 3,
                        },
                        {
                            portals: [
                                {
                                    name: "tgl",
                                    label: "Taschengeldladies.de",
                                },
                                {
                                    name: "thmlds",
                                    label: "Themenladies",
                                },
                                {
                                    name: "fkk",
                                    label: "FKK24.de",
                                },
                                {
                                    name: "forum",
                                    label: "Ladies-Forum.de",
                                },
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                            ],
                            lifetime: "90 Tage",
                            name: "gac_gb_container_id",
                            description:
                                "Enthält kampagnenbezogene Informationen. Wenn Sie Ihre Google Analytics- und Google Ads-Konten verknüpft haben, wird dieses Cookie von den Google Ads-Website-Conversion-Tags gelesen, es sei denn, Sie deaktivieren es. ",
                            label: "_gac_gb_*",
                            order: 4,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                                {
                                    name: "thmlds",
                                    label: "Themenladies",
                                },
                                {
                                    name: "fkk",
                                    label: "FKK24.de",
                                },
                                {
                                    name: "tgl",
                                    label: "Taschengeldladies.de",
                                },
                                {
                                    name: "forum",
                                    label: "Ladies-Forum.de",
                                },
                            ],
                            lifetime: "90 Tage",
                            name: "_gac_property_id",
                            description: "Enthält kampagnenbezogene Informationen für den Benutzer",
                            label: "_gac_*",
                            order: 6,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                                {
                                    name: "thmlds",
                                    label: "Themenladies",
                                },
                                {
                                    name: "fkk",
                                    label: "FKK24.de",
                                },
                                {
                                    name: "forum",
                                    label: "Ladies-Forum.de",
                                },
                                {
                                    name: "tgl",
                                    label: "Taschengeldladies.de",
                                },
                            ],
                            lifetime: "1 Minute",
                            name: "gat_gtag",
                            description: "Dient zur Verringerung der Anzahl der Datenübermittlungen an Google",
                            label: "_gat_gtag_*",
                            order: 10,
                        },
                        {
                            portals: null,
                            lifetime: "6 Monate",
                            name: "_utmz",
                            description:
                                "Speichert, von welcher Seite der Besucher kam: eine Suchmaschine (und wenn ja, das verwendete Suchwort), ein Link, oder von keiner vorherigen Seite (z. B. ein Lesezeichen oder eine eingegebene URL)",
                            label: "__utmz",
                            order: null,
                        },
                        {
                            portals: null,
                            lifetime: "1 Stunde",
                            name: "_utma",
                            description:
                                "Speichert die Anzahl der Besuche und die Zeit des ersten Besuchs, des vorherigen Besuchs und des aktuellen Besuchs.",
                            label: "__utma",
                            order: null,
                        },
                        {
                            portals: null,
                            lifetime: "30 Minuten",
                            name: "_utmb",
                            description:
                                "Wird verwendet, um zu schätzen, wie schnell die Besucher die Website verlassen, indem aufgezeichnet wird, wann ein Besuch beginnt und ungefähr endet.",
                            label: "__utmb",
                            order: null,
                        },
                        {
                            portals: null,
                            lifetime: "Bis Ende der Sitzung",
                            name: "_utmc",
                            description:
                                "Wird verwendet, um zu schätzen, wie schnell die Besucher die Website verlassen, indem aufgezeichnet wird, wann ein Besuch beginnt und ungefähr endet.",
                            label: "__utmc",
                            order: null,
                        },
                        {
                            portals: null,
                            lifetime: "10 Minuten",
                            name: "_utmt",
                            description: "Wird verwendet, um die Anfragerate zu drosseln.",
                            label: "__utmt",
                            order: null,
                        },
                    ],
                    order: 1,
                },
                {
                    owner: "Hotjar Limited, Malta",
                    description_consent:
                        "Wir nutzen Hotjar als Webanalysedient. Es wird verwendet, um Daten über das Benutzerverhalten zu sammeln. Hotjar kann auch im Rahmen von Umfragen und Feedbackfunktionen, die auf unserer Website eingebunden sind, von Ihnen bereitgestellte Informationen verarbeiten.",
                    processing_location:
                        'Europäische Union<div class="cookie-list-text"><span class="cookie-list-title">Rechtliche Grundlage der Verarbeitung</span><br> Art. 6 Abs. 1 S. 1 lit. a DSGVO</div>',
                    description_dse:
                        '            <p>\n                Cookierichtlinie:\n                <a href="https://help.hotjar.com/hc/en-us/articles/115011789248-Hotjar-Cookies">https://help.hotjar.com/hc/en-us/articles/115011789248-Hotjar-Cookies</a>\n            </p>\n            <p>\n                <b>Welche Art von Daten werden gesammelt?</b>\n                <ul>\n                    <li>Datum und Uhrzeit des Besuchs</li>\n                    <li>Gerätetyp</li>\n                    <li>Geografischer Standort</li>\n                    <li>IP-Adresse</li>\n                    <li>Mausbewegungen</li>\n                    <li>Besuchte Seiten</li>\n                    <li>Referrer URL</li>\n                    <li>Bildschirmauflösung</li>\n                    <li>Eindeutige Gerätekennung</li>\n                    <li>Sprachinformationen</li>\n                    <li>Gerätebestriebssystem</li>\n                    <li>Browser-Typ</li>\n                    <li>Klicks</li>\n                    <li>Domain-Name</li>\n                    <li>Eindeutige Benutzerkennung</li>\n                    <li>Antworten auf Umfragen</li>\n                </ul>\n            </p>',
                    name: "hotjar",
                    label: "Hotjar",
                    pivacy_policy_link: null,
                    collected_data:
                        "<ul>\n    <li>Datum und Uhrzeit des Besuchs</li>\n    <li>Gerätetyp</li>\n    <li>Geografischer Standort</li>\n    <li>IP-Adresse</li>\n    <li>Mausbewegungen</li>\n    <li>Besuchte Seiten</li>\n    <li>Referrer URL</li>\n    <li>Bildschirmauflösung</li>\n    <li>Eindeutige Gerätekennung</li>\n    <li>Sprachinformationen</li>\n    <li>Gerätebestriebssystem</li>\n    <li>Browser-Typ</li>\n    <li>Klicks</li>\n    <li>Domain-Name</li>\n    <li>Eindeutige Benutzerkennung</li>\n    <li>Antworten auf Umfragen</li>\n</ul>",
                    cookies: [
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                            ],
                            lifetime: "365 Tage",
                            name: "hotjar SessionUserID",
                            description:
                                "Stellt sicher, dass Daten von nachfolgenden Besuchen auf derselben Website derselben Benutzer-ID zugeordnet werden",
                            label: "_hjSessionUser_*",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                            ],
                            lifetime: "Bis Ende der Sitzung",
                            name: "hotjar CachedUserAttributes",
                            description:
                                "Ermöglicht es uns zu wissen, ob die im _hjUserAttributes Local Storage-Element gespeicherten Daten aktuell sind oder nicht",
                            label: "_hjHasCachedUserAttributes",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                            ],
                            lifetime: "2 Minuten, wird alle 30 Sekunden verlängert",
                            name: "hotjar UserAttributesHash",
                            description:
                                "Ermöglicht es zu wissen, wann sich ein Benutzerattribut geändert hat und aktualisiert werden muss",
                            label: "_hjUserAttributesHash",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                            ],
                            lifetime: "30 Minuten, wird verlängert bei Benutzeraktivität",
                            name: "hotjar Session",
                            description:
                                "Stellt sicher, dass nachfolgende Anfragen im Sitzungsfenster derselben Sitzung zugeordnet werden",
                            label: "_hjSession_*",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                            ],
                            lifetime: "Unter 100 ms, Cookie-Verfallszeit wird auf Sitzungsdauer gesetzt",
                            name: "hotjar CookieTest",
                            description:
                                "Überprüft, ob der Hotjar-Tracking-Code Cookies verwenden kann. Wenn ja, wird der Wert 1 gesetzt.\nWird fast unmittelbar nach der Erstellung gelöscht.",
                            label: "_hjCookieTest",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                            ],
                            lifetime: "Unter 100 ms",
                            name: "hotjar LocalStorageTest",
                            description:
                                "Überprüft, ob der Hotjar-Tracking-Code Local Storage verwenden kann.\nWenn ja, wird der Wert 1 gesetzt.",
                            label: "_hjLocalStorageTest",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                            ],
                            lifetime: "Unter 100 ms",
                            name: "hotjat SessionStorageTest",
                            description:
                                "Überprüft, ob der Hotjar-Tracking-Code Session Storage verwenden kann. Wenn ja, wird der Wert 1 gesetzt.",
                            label: "_hjSessionStorageTest",
                            order: null,
                        },
                        {
                            portals: [
                                {
                                    name: "lds",
                                    label: "Ladies.de",
                                },
                            ],
                            lifetime: "Bis zum Ende der Sitzung",
                            name: "hotjar TLDTest",
                            description:
                                "Ermöglicht, zu versuchen, den allgemeinsten Cookie-Pfad zu bestimmen, anstatt den Seitenhostnamen zu verwenden. Nach dieser Überprüfung wird das Cookie entfernt.",
                            label: "_hjTLDTest",
                            order: null,
                        },
                    ],
                    order: 2,
                },
            ],
            order: 2,
            timestamp: "2022-04-14T14:55:02.750809+02:00",
        },
    ],
    count: 2,
    pages: 1,
}

export const cookieModalAdditionalSelection = {
    data: [
        {
            portals: [
                {
                    name: "lds",
                    label: "Ladies.de",
                },
                {
                    name: "thmlds",
                    label: "Themenladies",
                },
                {
                    name: "fkk",
                    label: "FKK24.de",
                },
                {
                    name: "tgl",
                    label: "Taschengeldladies.de",
                },
                {
                    name: "kol",
                    label: "Kollegin.de",
                },
            ],
            choosable: true,
            name: "map_services",
            description:
                '<span class="cookie-title">Google Maps</span><br /><br /><p>Wenn Sie Google Maps auf unserer Webseite nutzen, können Informationen über Ihre Benutzung dieser Seite sowie Ihre IP-Adresse an einen Server in den USA übertragen und auf diesem Server gespeichert werden.</p>',
            label: "Kartendienste",
            order: 1,
            timestamp: "2022-08-05T12:20:02.440596+02:00",
        },
    ],
    count: 1,
    pages: 1,
}
